import classNames from 'classnames'

interface SingleTabData {
  value: string
  label: string
}

export interface TabSelectorProps {
  activeTab: string
  tabs: SingleTabData[]
  setActiveTab: (index: string) => void
  containerClassName?: string
  className?: string
  disableInactiveTab?: boolean
}

export const TabSelector = ({
  tabs,
  activeTab,
  containerClassName = '',
  className = '',
  setActiveTab,
  disableInactiveTab = false,
}: TabSelectorProps) => {
  return (
    <div
      className={classNames(
        {
          'flex border-1 border-gray-400 bg-dope-black': !containerClassName,
        },
        containerClassName,
      )}
    >
      {tabs.map((tab, index) => {
        const isInactiveTabDisabled =
          disableInactiveTab && tab.value !== activeTab
        return (
          <button
            role="tab"
            key={`tab-selector-${tab.label}`}
            onClick={() => setActiveTab(tab.value)}
            className={classNames(
              `flex flex-1 items-center justify-center py-2 px-1 text-white text-xs karla`,
              className,
              {
                'font-bold text-cyan-200 bg-gray-600/30 cursor-default':
                  tab.value === activeTab,
                'cursor-pointer !text-gray-400':
                  tab.value !== activeTab && !disableInactiveTab,
                'border-r border-gray-400': index !== tabs.length - 1,
                'cursor-not-allowed': isInactiveTabDisabled,
              },
            )}
            aria-pressed={tab.value === activeTab}
            disabled={isInactiveTabDisabled}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
